export default __webpack_public_path__ + "static/media/Astro_Sextile_White.3fd8e4f5.png";